import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function addCustomerUserMeter(customerUserMeter) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/addCustomerUserMeter',
    method: 'post',
    data: customerUserMeter
  })
}

/**
 * 查询业主用户仪表
 * @param id
 */
export function selectCustomerUserMeter(customerUserId) {
  return request({
    url: cmsServerContext + '/CustomerUserMeter/selectCustomerUserMeter/' + customerUserId,
    method: 'get'
  })
}
